module.exports = __webpack_public_path__ + "static/img/0.file-16.6500d2c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/0.file-16.png
// module id = ucuu
// module chunks = 53